import StopesPanelPage from './StopesPanelPage';

export default StopesPanelPage;
